export default __webpack_public_path__ + "static/media/Pipe Threading (2).1b39ae5c.jpg";